import { render } from "./Pricing.vue?vue&type=template&id=00714aa9&scoped=true"
import script from "./Pricing.vue?vue&type=script&lang=js"
export * from "./Pricing.vue?vue&type=script&lang=js"

import "./Pricing.vue?vue&type=style&index=0&id=00714aa9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-00714aa9"

export default script